export const LazyImageComponent = ({ src, alt, ...props }) => {
  if (src?.endsWith(".pdf")) {
    return <embed src={src} {...props} height="375" type="application/pdf" />;
  } else {
    return (
      <img
        src={src}
        alt={alt}
        width={100}
        height={100}
        {...props}
        loading="lazy"
      />
    );
  }
};
